import React, { Component } from 'react'
import { connect } from 'react-redux'
import Stix from './Stix'
import PropTypes from 'prop-types'
import * as actions from './actions'

class StixContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  // #region [life cycle]

  componentDidMount () {
    this.props.getPartners()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.supplierId !== this.props.supplierId) {
      this.props.getMileageConfigurations(
        this.props.catalogId,
        this.props.supplierId
      )
    }
  }

  // #endregion

  render () {
    // @ts-ignore
    return <Stix />
  }
}

const mapStateToProps = ({ stix, catalog, mileage }) => ({
  catalogId: catalog.id,
  supplierId: stix.supplierId,
  redemptionPoints: stix.redemptionPoints,
  mileageIsLoading: mileage.isLoading,
  configuration: stix.configuration
})

const mapDispatchToProps = dispatch => ({
  getMileageConfigurations: (catalogId, supplierId) => dispatch(actions.getMileageConfigurations(catalogId, supplierId)),
  getPartners: () => dispatch(actions.getPartnersStix())
})

StixContainer.propTypes = {
  supplierId: PropTypes.string,
  catalogId: PropTypes.number,
  getMileageConfigurations: PropTypes.func,
  getPartners: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(StixContainer)



// WEBPACK FOOTER //
// ./src/features/Stix/StixContainer.js